import { Injectable } from '@angular/core';
import { ListItem } from '../../shared/classes/list-item.class';
import { Day, Month } from '../../shared/classes/date.class';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private readonly firstBankdag = {
    2018: 2, 2019: 2, 2020: 2, 2021: 4, 2022: 3, 2023: 2, 2024: 2, 2025: 2, 2026: 2, 2027: 4, 2028: 3, 2029: 2, 2030: 2
  };

  getYears(): number[] {
    return this.range(2018, new Date().getFullYear());
  }

  getYearsAsListItems(): ListItem[] {
    const yearsListItems = this.getYears().map(year => new ListItem(year.toString(), year.toString(), false));
    yearsListItems[yearsListItems.length - 1].disabled = this.isBeforeFirstBankDayOfNewYear();
    return yearsListItems;
  }

  getMonths(year: number, month = 0): Month[] {
    let months = Month.createMonths();
    if (this.isCurrentYear(year)) {
      const currentMonth = month === 0 ? this.getCurrentMonth() : month;
      months = this.disableNextMonthAndForward(currentMonth, months);
      return months;
    } else {
      months.unshift(new Month('Okänd', '-1'));
      return months;
    }
  }

  getDays(year = 0, month = 0): Array<Day> {
    const days = this.getDaysInMonth(year, month);
    const listOfDays = Day.createDays(days);

    const date = new Date();
    const currentDay = date.getDate();
    const currentMonth = date.getMonth() + 1; // getMonth räknar från 0 till 11, inte 1 till 12
    const currentYear = date.getFullYear();
    if (+year === currentYear && +month === currentMonth) {
      return this.disabledNextDayAndForward(currentDay, listOfDays);
    } else {
      listOfDays.unshift(new Day('Okänd', '-1', false));
      return listOfDays;
    }
  }

  isBefore(dateString1: string, dateString2: string): boolean {
    const d1 = Date.parse(dateString1);
    const d2 = Date.parse(dateString2);
    return d1 < d2;
  }

  /**
   * Compares two Date objects and returns e number value that represents
   * the result:
   * 0 if the two dates are equal.
   * 1 if the first date is greater than second.
   * -1 if the first date is less than second.
   * @param date1 First date object to compare.
   * @param date2 Second date object to compare.
   */
  compareDate(date1: string, date2: string): number | undefined {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    const same = d1.getTime() === d2.getTime();
    if (same) {
      return 0;
    }
    if (d1 > d2) {
      return 1;
    }
    if (d1 < d2) {
      return -1;
    }
  }

  isBeforeFirstBankDayOfNewYear(): boolean {
    const date = new Date();

    const currentMonth = date.getMonth() + 1;
    if (currentMonth !== 1) {
      return false;
    }
    const currentYear = date.getFullYear();
    const currentDayOfMonth = date.getDate();
    const firstBankDayOfCurrentYear = this.firstBankdag[currentYear];
    return currentDayOfMonth < firstBankDayOfCurrentYear;
  }

  private isCurrentYear(year: number): boolean {
    const currentYear = new Date().getFullYear();
    return year === currentYear;
  }

  private getCurrentMonth(): any {
    return new Date().getMonth();
  }

  private disableNextMonthAndForward(currentMonth: any, months: Month[]) {
    const nextMonth = currentMonth + 1;
    for (let i = nextMonth; i < months.length; i++) {
      const m = months[i];
      m.disabled = true;
    }
    return months;
  }

  private disabledNextDayAndForward(currentDay: number, days: Day[]): Day[] {
    for (let i = currentDay; i < days.length; i++) {
      const d = days[i];
      d.disabled = true;
    }
    return days;
  }

  private getDaysInMonth(year, month): number {
    return new Date(year, month, 0).getDate();
  }

  private range(start, end) {
    if (start === end) {
      return [start];
    }
    return [start, ...this.range(start + 1, end)];
  }
}
